import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-error-not-found',
  template: `
        <div class="error-fatal">
            <div class="ui-g-12">
                <div class="content-error">
                    <div class="error-icon">
                        <i class="fa fa-warning"></i>
                    </div>
                    <div class="error-title">404. Página Não Encontrada</div>
                    <div class="error-description">
                        A página solicitada, não foi encontrada<br />
                        Verifique o endereço ou tente novamente mais tarde.
                    </div>
                </div>
            </div>
        </div>
	`
})
export class ErrorNotFoundComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
